var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAlignText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.625C4 7.27982 4.27982 7 4.625 7H18.375C18.7202 7 19 7.27982 19 7.625C19 7.97018 18.7202 8.25 18.375 8.25H4.625C4.27982 8.25 4 7.97018 4 7.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 10.75C7.75 10.4048 8.02982 10.125 8.375 10.125H18.375C18.7202 10.125 19 10.4048 19 10.75C19 11.0952 18.7202 11.375 18.375 11.375H8.375C8.02982 11.375 7.75 11.0952 7.75 10.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.875C4 13.5298 4.27982 13.25 4.625 13.25H18.375C18.7202 13.25 19 13.5298 19 13.875C19 14.2202 18.7202 14.5 18.375 14.5H4.625C4.27982 14.5 4 14.2202 4 13.875Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 17C7.75 16.6548 8.02982 16.375 8.375 16.375H18.375C18.7202 16.375 19 16.6548 19 17C19 17.3452 18.7202 17.625 18.375 17.625H8.375C8.02982 17.625 7.75 17.3452 7.75 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlignText);
export default __webpack_public_path__ + "static/media/right-align-text.7c6145219b58126deb10da5f8cd2b650.svg";
export { ForwardRef as ReactComponent };